import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmData {
    label?: string;
    message: string;
}

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.css'],
})
export class ConfirmComponent implements OnInit {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmData,
        public dialogRef: MatDialogRef<ConfirmComponent>
    ) {}

    ngOnInit(): void {}

    public confirmed(result: boolean) {
        this.dialogRef.close({ data: result });
    }
}
